import { render, staticRenderFns } from "./StudentExamineeidentity.vue?vue&type=template&id=2f8623ce&scoped=true"
import script from "./StudentExamineeidentity.vue?vue&type=script&lang=js"
export * from "./StudentExamineeidentity.vue?vue&type=script&lang=js"
import style0 from "./StudentExamineeidentity.vue?vue&type=style&index=0&id=2f8623ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8623ce",
  null
  
)

export default component.exports